import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 192,
	height: 192,
	viewBox: "0 0 192 192",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M92.5357 46.5C94.0753 43.8333 97.9243 43.8333 99.4639 46.5L152.003 137.5C153.542 140.167 151.618 143.5 148.539 143.5H43.4609C40.3817 143.5 38.4572 140.167 39.9968 137.5L92.5357 46.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.5357 46.5C94.0753 43.8333 97.9243 43.8333 99.4639 46.5L152.003 137.5C153.542 140.167 151.618 143.5 148.539 143.5H43.4609C40.3817 143.5 38.4572 140.167 39.9968 137.5L92.5357 46.5Z",
			stroke: "#272525",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91 84C91 81.2386 93.2386 79 96 79C98.7614 79 101 81.2386 101 84V104C101 106.761 98.7614 109 96 109C93.2386 109 91 106.761 91 104V84Z",
			stroke: "#272525",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101 124C101 126.761 98.7614 129 96 129C93.2386 129 91 126.761 91 124C91 121.239 93.2386 119 96 119C98.7614 119 101 121.239 101 124Z",
			stroke: "#272525",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
export default SvgWarning;
